// Plyr a richiesta. Serve in due soli punti - i video incorporati negli
// articoli del blog (<oembed> di CKEditor) e i player delle landing - e prima
// veniva scaricato ed eseguito su tutto il sito.
//
// Il CSS viaggia col chunk: lasciato in app.scss resterebbe bloccante ovunque.

let plyrPromise = null;

window.loadPlyr = function () {
    if (!plyrPromise) {
        plyrPromise = Promise.all([
            import("plyr"),
            import("plyr/dist/plyr.css"),
        ]).then(([module]) => {
            const Plyr = module.default ?? module;
            window.Plyr = Plyr;
            return Plyr;
        });
    }

    return plyrPromise;
};
